<template>
  <v-dialog v-model="dialog" width="350">
    <v-card>
      <v-card-title>
        <v-icon class="pr-2">mdi-notebook</v-icon>
        <span class="title-2">ノート情報</span>
        <v-spacer />
        <v-btn text @click="sourceDialog = true" class="mr-n5"
          ><v-icon>mdi-text-subject</v-icon>ソース
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>ノート作成日時</v-list-item-title>
            <v-list-item-subtitle>{{
              note ? dateService.getFormatted(note.created) : '-'
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>ノート最終更新日時</v-list-item-title>
            <v-list-item-subtitle>{{
              note ? dateService.getFormatted(note.updated) : '-'
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>この端末でキャッシュした日時</v-list-item-title>
            <v-list-item-subtitle>{{
              note ? dateService.getFormatted(note.cached) : '-'
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Update Sequence Number</v-list-item-title>
            <v-list-item-subtitle>{{
              note ? note.updateSequenceNum : '-'
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="close(true)">
          <v-icon color="grey" left>mdi-reload</v-icon>再読み込み
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click="close(false)">閉じる</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="sourceDialog">
      <v-card>
        <v-card-title>
          <v-icon class="pr-2">mdi-text-subject</v-icon>Source (ENML)
          <v-spacer></v-spacer>
          <v-btn text @click="sourceDialog = false">閉じる</v-btn>
        </v-card-title>
        <v-card-text>{{ note ? note.content : '' }}</v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import dateService from '@/services/DateService'

export default {
  data() {
    return {
      dialog: false,
      resolve: undefined,
      note: {},
      sourceDialog: false
    }
  },
  computed: {
    dateService: () => dateService
  },
  methods: {
    open(note) {
      this.note = note
      this.dialog = true
      return new Promise(resolve => (this.resolve = resolve))
    },
    close(result) {
      this.dialog = false
      this.note = undefined
      this.resolve(result)
    }
  }
}
</script>

<style lang="scss" scoped></style>
